// Fork JavaMifi: variabel di URL Dashboard App, mis.
//   https://app.example.com/order?hp={{contact.phone_number}}&chat={{conversation.id}}
// Nilai diambil dari { conversation, contact, agent } lalu di-encode untuk URL.
// Variabel yang tidak dikenal / kosong diganti string kosong.
const PLACEHOLDER = /\{\{\s*([\w.]+)\s*\}\}/g;

export const DASHBOARD_APP_URL_VARIABLES = [
  'conversation.id',
  'conversation.inbox_id',
  'contact.id',
  'contact.name',
  'contact.phone_number',
  'contact.email',
  'contact.identifier',
  'contact.custom_attributes.<key>',
  'agent.id',
  'agent.name',
  'agent.email',
];

export const hasUrlVariables = template => /\{\{[\s\w.]+\}\}/.test(template);

export const renderDashboardAppUrl = (template, context) =>
  template.replace(PLACEHOLDER, (_, path) => {
    const value = path
      .split('.')
      .reduce((object, key) => (object == null ? undefined : object[key]), context);
    return value == null ? '' : encodeURIComponent(value);
  });

// Untuk validasi form: URL dianggap sah kalau sah setelah variabel diisi contoh.
export const isValidDashboardAppUrl = template => {
  if (!template) return false;
  try {
    const url = new URL(template.replace(PLACEHOLDER, 'x'));
    return ['http:', 'https:'].includes(url.protocol);
  } catch {
    return false;
  }
};
